import { AUTHENTICATED, AUTHENTICATION_ERROR, UNAUTHENTICATED  } from './types';
import axios from 'axios';


const URL = process.env.REACT_APP_API_URL;
const endpoints = {
    checkAccount: `${URL}/auth-users/check-account/`,
    confirmAccount: `${URL}/auth-users/confirm-account/`,
    forgotPassword: `${URL}/auth-users/forgot-password/`,
    changePassword: `${URL}/auth-users/change-password/`,
    login: `${URL}/auth-users/login/`,
    resetPassword: `${URL}/auth-users/reset-password/`,
};


export const signInAction = ({ email, password }, history) => {
    return async dispatch => {
        try {
            const res = await axios.post(endpoints.login, { username: email, password });
            localStorage.setItem('pmt-token', res.data.token);
            localStorage.setItem('pmt-email', res.data.token);
            localStorage.setItem('pmt-user-data', JSON.stringify(res.data));
            // axios.interceptors.request.use(config => {
            //     config.headers.Authorization =  res.data.token ? `Bearer ${res.data.token}` : '';
            //     return config;
            // });
            dispatch({ type: AUTHENTICATED , payload: res.data});
            history.push('/dashboard');

        } catch(error) {
            dispatch({
                type: AUTHENTICATION_ERROR,
                payload: 'Invalid email or password'
            });
        }
    };
};

export const checkAccountAction = token => {
    return async dispatch => {
        return axios.post(endpoints.checkAccount, { token });
    };
};

export const signOutAction = () => {
    localStorage.clear();
    return {
        type: UNAUTHENTICATED
    };
};

export const confirmAccountAction = data => {
    return async dispatch => {
        return axios.post(endpoints.confirmAccount, data);
    };
};





// WEBPACK FOOTER //
// ./src/actions/auth.ts